import { api } from "@/api/axios.ts";
import {
  ApiApiTokenCreated,
  ApiApiTokenGenerate,
  ApiApiUser,
  ApiApiUserFilter,
  ApiApiUserPagedData,
  ApiApiUserSave,
} from "@/types/api-user.types.ts";

export const apiApiUser = {
  search: async function (payload: ApiApiUserFilter, signal?: AbortSignal) {
    return api.post<ApiApiUserPagedData>("/api/v1/api-users/search", payload, signal);
  },
  getById: async function (id: number, signal?: AbortSignal) {
    return api.get<ApiApiUser>(`/api/v1/api-users/${id}`, {}, signal);
  },
  create: async function (payload: ApiApiUserSave) {
    return api.post<ApiApiUser>("/api/v1/api-users", payload);
  },
  update: async function (id: number, payload: ApiApiUserSave) {
    return api.put<ApiApiUser>(`/api/v1/api-users/${id}`, payload);
  },
  delete: async function (id: number) {
    return api.delete(`/api/v1/api-users/${id}`);
  },
  generateToken: async function (apiUserId: number, payload: ApiApiTokenGenerate) {
    return api.post<ApiApiTokenCreated>(`/api/v1/api-users/${apiUserId}/tokens`, payload);
  },
};
